"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listTicketResult = listTicketResult;
exports.createTicketResult = createTicketResult;
exports.readTicketResult = readTicketResult;
exports.updateTicketResult = updateTicketResult;
exports.deleteTicketResult = deleteTicketResult;
exports.allTicketResult = allTicketResult;

var _request = _interopRequireDefault(require("@/utils/request"));

function listTicketResult(query) {
  return (0, _request.default)({
    url: '/workOrderResult/list',
    method: 'get',
    params: query
  });
}

function createTicketResult(data) {
  return (0, _request.default)({
    url: '/workOrderResult/create',
    method: 'post',
    data: data
  });
}

function readTicketResult(data) {
  return (0, _request.default)({
    url: '/workOrderResult/read',
    method: 'get',
    data: data
  });
}

function updateTicketResult(data) {
  return (0, _request.default)({
    url: '/workOrderResult/update',
    method: 'post',
    data: data
  });
}

function deleteTicketResult(data) {
  return (0, _request.default)({
    url: '/workOrderResult/delete',
    method: 'post',
    data: data
  });
}

function allTicketResult() {
  return (0, _request.default)({
    url: '/workOrderResult/all',
    method: 'get'
  });
}